import { render, staticRenderFns } from "./edge.vue?vue&type=template&id=a8d39ece&lang=html&"
import script from "./edge.vue?vue&type=script&lang=js&"
export * from "./edge.vue?vue&type=script&lang=js&"
import style0 from "./edge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edge.vue"
export default component.exports